export default class Constants {
  static refreshTime = 90000; // In milliseconds
  static entriesPerTable = 30;
  static tables = 3;
  static playerNameInLeaderboardCharacterLimit = 18;
  static tournamentId = 2;
  static golfCourseId = 2289;
}
